import React, {useState} from "react";
import {FileUploader} from "react-drag-drop-files";
import {SelectMain} from "../inputs";
import {DefaultUploadedFileCard} from "./defaultUploadedFileCard";
import {Svg} from "assets";
import {fileMaxSize} from "utils";


export const UploadSingle = (
    {
        classNameWrapper,
        selectOptions,
        currentFile,
        setCurrentFile,
        supportedFormats,
        backError,
        setBackError,
    }) => {
    const [error, setError] = useState(false);
    const [isHoveredProfile, toggleHoveredProfile] = useState(false);
    const fileTypes = supportedFormats || ["JPEG", "JPG", "PNG", "GIF"];


    const handleChange = (e) => {
        if (e && e.size > fileMaxSize) {
            setError(true);
        } else {
            setError(false);
            setBackError?.(false)

            const image = e && URL.createObjectURL(e);
            setCurrentFile?.({
                file: e,
                url: image,
            });
        }
    };

    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setCurrentFile?.(null);
    };

    return (
        <div
            className={`upload-section-box ${
                classNameWrapper ? classNameWrapper : ""
            }`}
        >
            <div
                className={`file-uploader ${backError ? "file-uploader-error" : ""}`}
                style={{background: isHoveredProfile ? '#E4F3FF' : ''}}
                onDragEnter={() => toggleHoveredProfile(true)}
                onDragLeave={() => toggleHoveredProfile(false)}
            >
                <FileUploader
                    classes={`new-file-uploader ${isHoveredProfile ? 'new-file-uploader-hover' : ''}`}
                    name="file"
                    multiple={false}
                    types={fileTypes}
                    handleChange={handleChange}
                    onDraggingStateChange={(isDragging) => {
                        toggleHoveredProfile(isDragging);
                    }}
                    dropMessageStyle={{display: 'none'}}
                    children={<div></div>}
                />

                <div className="upload-info-box">
                    <div className='drag-drop-info-texts-svg'>
                        <Svg.UploadSvg/>

                        <p className="drag-drop-text">
                            Drag and Drop or
                            <label
                                className='drag-drop-text-choose'
                                htmlFor='file'
                                onClick={e => e.stopPropagation()}
                            >
                                <input style={{display: "none"}}/>
                                <i className="fa fa-cloud-upload"/>
                                <span>Choose File</span>
                            </label>
                        </p>


                        {error ? (
                            <p className='information-box' style={{color: 'red'}}>Max size must be 10 MB</p>
                        ) : (
                            <p className='information-box'>
                                Supported file {fileTypes?.map((f) => (` ${f?.toLowerCase()}`))}. Max Size 10MB.
                            </p>
                        )}
                    </div>

                    {(selectOptions && selectOptions?.control && selectOptions?.name) &&
                        <div style={{width: "70%"}}>
                            <SelectMain
                                list={selectOptions.list}
                                renderLabel={(option) => option?.name}
                                name={selectOptions?.name}
                                control={selectOptions?.control}
                                labelHeader={selectOptions?.labelHeader || ''}
                                placeholder={selectOptions?.placeholder || "Select Option"}
                                loadType={selectOptions?.loadType || ''}
                                selectedValue={selectOptions?.selectedValue || 'id'}
                                rules={selectOptions?.rules}
                            />
                        </div>
                    }

                    {currentFile && (
                        <DefaultUploadedFileCard file={currentFile} handleDelete={handleDelete} />
                    )}
                </div>

            </div>
        </div>
    );
};
